(() => {
  const initialize = () => document.querySelectorAll('.hdx-protocol').forEach(root => {
    if (root.dataset.hdxProtocolReady) return;
    root.dataset.hdxProtocolReady = 'true';
    const purchase = root.querySelector('.hdx-system__purchase');
    const submit = purchase?.querySelector('button[type="submit"]');
    const sticky = root.querySelector('[data-hdx-protocol-sticky]');
    const end = root.querySelector('[data-hdx-protocol-end]');
    const dialog = root.querySelector('dialog');
    root.querySelectorAll('[data-hdx-protocol-buy]').forEach(button => button.addEventListener('click', () => {
      if (!submit || submit.disabled) return;
      submit.click();
    }));
    if (submit) new MutationObserver(() => {
      root.querySelectorAll('[data-hdx-protocol-buy]').forEach(button => {
        button.disabled = submit.disabled;
        button.setAttribute('aria-busy', submit.getAttribute('aria-busy') || 'false');
      });
      const error = purchase.querySelector('[data-hdx-system-cart-error]');
      if (error && !error.hidden) purchase.scrollIntoView({behavior:'smooth',block:'center'});
    }).observe(purchase, {subtree:true,attributes:true,attributeFilter:['disabled','aria-busy','hidden']});
    if (sticky && purchase && end && 'IntersectionObserver' in window) {
      let pastPurchase = false, atEnd = false;
      const update = () => {
        const show = pastPurchase && !atEnd;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(entries => {
        pastPurchase = entries[0].boundingClientRect.bottom < 0;
        update();
      }).observe(purchase);
      new IntersectionObserver(entries => {atEnd = entries[0].isIntersecting;update();}).observe(end);
    }
    if (dialog && typeof dialog.showModal === 'function') {
      root.querySelectorAll('[data-hdx-preview]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const img = dialog.querySelector('img');
        img.src = link.href;
        img.alt = link.querySelector('img')?.alt || '';
        dialog.showModal();
      }));
      dialog.addEventListener('click', event => {if(event.target === dialog) dialog.close();});
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
